<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-firewall`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M42 4a2 2 0 012 2v36a2 2 0 01-2 2H6a2 2 0 01-2-2V6a2 2 0 012-2h36zM17 32H8v8h9v-8zm4 0h19v8H21v-8zm6-12H8v8h19v-8zm4 0h9v8h-9v-8zM17 8H8v8h9V8zm4 0h19v8H21V8z" fill-opacity="1"/></svg>
</template>
<script>

export default {
  name: 'IconFirewall',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
